import { useQuery } from "@tanstack/react-query";
import { syncService } from "@/services/syncService";

export function useSyncStatus() {
  return useQuery({ queryKey: ["sync", "status"], queryFn: syncService.getStatus });
}
